import axios from 'axios';
import getConfig from '../config';
const config = getConfig();

export const getThreadByThreadId = async (thread_id) => {
  const api_url = config.luigi.domain + config.luigi.services.thread + thread_id;
  const response = await axios.get(api_url);
  const thread = response.data || null;
  return thread;
}
